import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { ISelectedContract, LoggedInUserSettings } from 'src/app/core/services/settings/logged-in-user-settings';
import { filter } from 'rxjs/operators';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { combineLatest } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { UserClaims } from 'src/app/model/okta/userClaims';
import { FeatureGuard } from '../../../../core/guards/feature.guard';
import { BILLINGANDPAYMENT, DTEID } from '../../../../core/constants/feature-key.constants';
import { ContractGuard } from '../../../../core/guards/contract.guard';
import { PreInitSettingsService } from '../../../../core/services/settings/pre-init-setting.service';
import { ADPResourceService } from 'digital-core';

@Component({
  selector: 'pgh-billing-info-and-history',
  templateUrl: './billing-info-and-history.component.html',
  styleUrls: ['./billing-info-and-history.component.scss'],
})
export class BillingInfoAndHistoryComponent implements OnInit {
  @ViewChild(MatTabGroup) tabs: MatTabGroup;
  selectedContract: ISelectedContract;
  user: UserClaims;
  originalTitle = '';
  updatePaymentMessage: any;
  isLoaded: boolean = false;
  isActive: boolean = false;
  shouldRedirectToHome: boolean = false;
  tabData: any;

  constructor(
    private userSettings: LoggedInUserSettings,
    private title: Title,
    private featureGuard: FeatureGuard,
    private contractGuard: ContractGuard,
    private resourceService: ADPResourceService,
    private preInitSettings: PreInitSettingsService
  ) {}

  ngOnInit(): void {
    this.originalTitle = this.title.getTitle();
    this.tabData = {
      paymentBillingTabLabel: this.resourceService.getViewLabel('Account_Billing_Payment_Tab_Text'),
      paymentHistoryTabLabel: this.resourceService.getViewLabel('Account_Payment_History_Tab_Text'),
    };

    combineLatest([this.userSettings.$selectedContract, this.userSettings.$userClaims])
      .pipe(filter(([a, b]) => a !== null && b !== null))
      .subscribe(([selected, userClaims]: [ISelectedContract, UserClaims]) => {
        this.selectedContract = selected;
        this.user = userClaims;
        this.isLoaded = false;
        const checkExpiration = this.preInitSettings.getSiteSettings().id === DTEID;
        this.isActive = this.contractGuard.activateGuard(this.selectedContract, false, checkExpiration);

        if (this.isActive) {
          const cancelledOrExpiredHasFullAccess = this.resourceService.isPortalSettingTrue(
            'Global_CancelledOrExpiredContract_HasFullAccess'
          );
          this.shouldRedirectToHome =
            (this.selectedContract.isExpired || this.selectedContract.isCancelled) && !cancelledOrExpiredHasFullAccess;
        }
        if (this.featureGuard.canActivate(this.selectedContract.dealerId, BILLINGANDPAYMENT)) {
          this.isLoaded = true;
        }
      });
  }

  onTabChange(event: MatTabChangeEvent) {
    const tab = event.tab.textLabel;
    const hasTitle = this.originalTitle && this.originalTitle.length > 0;
    const url =
      tab === this.tabData?.paymentHistoryTabLabel
        ? '/payment-history'
        : tab === this.tabData?.paymentBillingTabLabel
          ? '/payment-info'
          : '/payment-info';

    this.title.setTitle(hasTitle ? this.originalTitle + ' | ' + event.tab.textLabel : event.tab.textLabel);
  }

  onCloseMessageClicked() {
    this.updatePaymentMessage = undefined;
  }
}
